
import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "react-toastify/dist/ReactToastify.css";

function Login() {
  const [mobile_no, setMobile] = useState("");
  const [aadhaar_no, setAadhaar] = useState("");
  const [remember, setRemember] = useState(false);
  const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!remember) {
      toast.error("Please check Remember me");
      return;
    }

    try {
      const res = await axios.post("https://api.statixtrading.in/admin-login", {
        mobile_no,
        aadhaar_no,
      });

      const storage = remember ? localStorage : sessionStorage;
      storage.setItem("user", JSON.stringify(res.data.user));

      setMessage(res.data.message);
      toast.success(res.data.message || "Login successful");

      setTimeout(() => {
        navigate("/admin/dashboard");
      }, 1500);

    } catch (err) {
      const msg = err?.response?.data?.message || "Server error";
      setMessage(msg);
      toast.error(msg);
    }
  };

  return (
    <div style={styles.container}>
      <ToastContainer position="top-center" autoClose={2000} />

      <div style={styles.card}>
        <h1 style={{ marginBottom: "25px" }}>Sign In</h1>

        <form onSubmit={handleLogin}>

          <input
            type="text"
            value={mobile_no}
            onChange={(e) => setMobile(e.target.value)}
            placeholder="Mobile Number"
            style={styles.input}
          />

      
          <div style={styles.passwordContainer}>
            <input
              type={showPassword ? "text" : "password"}
              value={aadhaar_no}
              onChange={(e) => setAadhaar(e.target.value)}
              placeholder="Password"
              style={styles.passwordInput}
            />

            <span
              onClick={() => setShowPassword(!showPassword)}
              style={styles.eyeIcon}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          <div
            style={{
              marginBottom: "20px",
              textAlign: "left",
              display: "flex",
              alignItems: "center",
              gap: "8px"
            }}
          >
            <label>
              <input
                type="checkbox"
                checked={remember}
                onChange={(e) => setRemember(e.target.checked)}
              />
              Remember me
            </label>
          </div>

          <button type="submit" style={styles.button}>
            LOGIN
          </button>
        </form>

        {message && <div style={{ marginTop: "10px" }}>{message}</div>}
      </div>
    </div>
  );
}

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#f5f5f5",
  },

  card: {
    width: "380px",
    padding: "30px",
    borderRadius: "20px",
    background: "linear-gradient(135deg, #7f5af0, #4b9be6)",
    color: "#fff",
    textAlign: "center",
  },

  input: {
    width: "100%",
    padding: "12px",
    borderRadius: "30px",
    marginBottom: "15px",
    border: "none",
    outline: "none",
  },

  passwordContainer: {
    position: "relative",
    width: "100%",
    marginBottom: "15px",
  },

  passwordInput: {
    width: "100%",
    padding: "12px 45px 12px 12px",
    borderRadius: "30px",
    border: "none",
    outline: "none",
  },

  eyeIcon: {
    position: "absolute",
    right: "15px",
    top: "50%",
    transform: "translateY(-50%)",
    cursor: "pointer",
    color: "#555",
  },

  button: {
    width: "100%",
    padding: "12px",
    borderRadius: "30px",
    border: "none",
    cursor: "pointer",
    background: "#fff",
    color: "#000",
    fontWeight: "bold",
  },                             
};

export default Login;